// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Qs from 'qs'
import ElementUI from 'element-ui'
import Vuex from 'vuex'
import store from './store/index.js'
import URL from './api/api.js'
import GetDate from './util/date.js'
Vue.prototype.URL = URL
Vue.prototype.GetDate = GetDate
Vue.use(Vuex)
//vxe-table
// import 'font-awesome/scss/font-awesome.scss'
import XEUtils from 'xe-utils'
import VXEUtils from 'vxe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'
Vue.prototype.XEUtils = XEUtils
// Vue.use(VXEUtils,XEUtils)
Vue.use(VXETable)
VXETable.use(VXETablePluginElement)
//密码加密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
//引入ele样式
ElementUI.Dialog.props.closeOnClickModal.default = false
ElementUI.Dialog.props.lockScroll.default = false
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
import { showLoading, hideLoading } from './components/modal/loading/loading.js'

Vue.config.productionTip = false
Vue.prototype.$axios = axios

import * as moment from 'moment'
Vue.prototype.$moment = moment

// table 高度
import tableHeight from './assets/js/index.js'
Vue.use(tableHeight)

//动态表格
// import { PublicTable } from './components/page/base/index.js'


// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
  config => {
    let token = sessionStorage.getItem('Authorization')
    if (token) {
      config.headers.Authorization = token
      if (!config.url.endsWith('/api/SPSupply/GetAlarms'))
        showLoading()
    }
    return config;
  },
  error => {
    hideLoading()
    console.log('错误')
    return Promise.reject(error);
  })

// 是否正在刷新的标记
let isRefreshing = false;
// 重试队列，每一项将是一个待执行的函数形式
let requests = [];
let newToken = '';

axios.defaults.withCredentials = true;
// 响应拦截器
axios.interceptors.response.use(response => {
  hideLoading()
  return response
}, error => {
  // console.log(error.response)
  let refresh_token = sessionStorage.getItem('refresh_token')
  if (error.response) {
    switch (error.response.data.code) {
      case 400:
        if (error.response.headers["expires"]) {
          var config = error.response.config;
          console.log("token过期");
          hideLoading()
          //通过刷新token获取请求token
          if (!isRefreshing) {
            isRefreshing = true;
            let params = {
              grant_type: 'refresh_token',
              refresh_token: refresh_token,
              client_Id: 'Web',
            }
            return axios.post(URL.adminUrl + 'Values/RefreshToken', params)
              .then(response => {
                console.log(response)
                hideLoading()
                newToken = response.data.data.access_token;
                //未进行刷新
                store.commit("changeLogin", {//vuex中修改相关信息
                  Authorization: response.data.data.access_token,
                  refresh_token: response.data.data.refresh_token,
                }); //登录

                return axios(config);
              })
              .catch(error => {
                hideLoading()
                ElementUI.Message({
                  message: "token过期:",
                  type: 'warning'
                });
                store.commit('DelToken');
                router.replace({
                  path: "/login",
                  query: {
                    redirect: router.currentRoute.fullPath//登录之后跳转到对应页面
                  }
                });
              }).finally(() => {
                isRefreshing = false;
                requests.forEach(cb => cb(newToken));
                // 重试完了别忘了清空这个队列
                requests = [];
              })
          } else {
            hideLoading()
            // 正在刷新token，返回一个未执行resolve的promise
            return new Promise((resolve) => {
              // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
              requests.push((token) => {
                config.headers.Authorization = token
                resolve(axios(config))
              });
            });
          }
        } else {
          hideLoading()
          console.log(error.response)
          store.commit('DelToken');
          router.replace({
            path: "/login",
            query: {
              redirect: router.currentRoute.fullPath//登录之后跳转到对应页面
            }
          });
        }
        break;
      case 500:
        ElementUI.Message({
          message: error.response.data.msg,
          type: 'error'
        });
        hideLoading()
        store.commit('DelToken');
        router.replace({
          path: "/login",
          query: {
            redirect: router.currentRoute.fullPath//登录之后跳转到对应页面
          }
        });
        break;
      default:
        if (error.response.data.msg != undefined) {
          ElementUI.Message({
            message: error.response.data.msg,
            type: 'error'
          });
        } else {
          ElementUI.Message({
            message: error.response.data.Message,
            type: 'error'
          });
        }

        hideLoading()
        // store.commit('DelToken');
        // router.replace({
        //   path: "/login",
        //   query: {
        //     redirect: router.currentRoute.fullPath//登录之后跳转到对应页面
        //   }
        // });
        break;
    }
  }
  return Promise.reject(error)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js